import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function ConsumerDashboard({ user, savedFacilities = [] }) {
  return (
    <MainLayout user={user}>
      <div className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">My Dashboard</h1>
          
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Saved Communities</CardTitle>
              </CardHeader>
              <CardContent>
                {savedFacilities.length > 0 ? (
                  <ul className="space-y-2">
                    {savedFacilities.map((facility) => (
                      <li key={facility.id} className="p-2 border-b">
                        {facility.name}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500">You haven't saved any communities yet.</p>
                )}
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle>My Account</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-medium">Email</h3>
                    <p>{user.email}</p>
                  </div>
                  <div>
                    <h3 className="font-medium">Account Type</h3>
                    <p>Consumer</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
